let baseUrl = '';

if (process.env.NODE_ENV == 'development') {
  baseUrl = 'http://localhost:8081/api'; 

}else if(process.env.NODE_ENV == 'production'){
  baseUrl ='https://speedupcoursescheduleservertest.azurewebsites.net/api';
}

export {
  baseUrl
}


// WEBPACK FOOTER //
// ./src/config/env.js